import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Header, NarrowContainer, Section, Title } from 'components/layout'
import { meta } from 'helpers/decorators'
import config from 'config'

@meta({
  title: 'Assessment sent successfully',
  intlKey: 'pageTitle.assessment_send_successfully'
})
class AssessmentSuccess extends Component {
  static propTypes = {}

  redirectToFoLogin = () => {
    window.location.replace(`${config.foUrl}?isAwardStaff=true`)
    return false
  }

  render() {
    const linkText = (
      <FormattedMessage
        id="button.back_to_home"
        defaultMessage="Back to Home"
      />
    )

    return (
      <div>
        <Header />
        <Section>
          <NarrowContainer>
            <div className="base-margin">
              <Title intlKey="pageTitle.assessment_send_successfully" h2>
                Assessment sent successfully
              </Title>
              {config.foUrl
                ? <a href={config.foUrl} className="btn" onClick={this.redirectToFoLogin}>{linkText}</a>
                : <Link to={`${config.publicPath}/`} className="btn">{linkText}</Link>
              }
            </div>
          </NarrowContainer>
        </Section>
      </div>
    )
  }
}

export default AssessmentSuccess
